import React from 'react'
import { isPartnerTest } from '../utility'
import { useAllPartners } from 'shared/hooks/partners.hooks'
import { PartnerType } from '../../products/types'
import { ItemSelect } from './ItemSelect'
import { keyTest } from '../../../../utility'
import { Box } from '@mui/material'

export function PartnerDisplay<T extends { id: number }>({
  item,
  columnData: { key: partnerKey },
}: {
  item: T
  columnData: { key: string }
}) {
  if (!keyTest(item, partnerKey)) return <Box />
  const { [partnerKey]: partner } = item
  const asPartner: PartnerType | undefined = isPartnerTest(partner)
    ? partner
    : undefined
  if (!asPartner) return <Box />
  return <Box>{`${asPartner.id}: ${asPartner.name}`}</Box>
}

export function PartnerEdit<T extends { id: number }>({
  item,
  columnData: { key: partnerKey, setKey },
}: {
  item: T
  columnData: { key: string; setKey?: string }
}) {
  const hasKey = keyTest(item, partnerKey)
  const partner = hasKey ? item[partnerKey] : undefined
  const asPartner: PartnerType | undefined = isPartnerTest(partner)
    ? partner
    : undefined
  return <PartnerSelect setKey={setKey ?? partnerKey} initialItem={asPartner} />
}

function PartnerSelect({
  initialItem,
  setKey,
}: {
  initialItem?: PartnerType
  setKey: string
}) {
  const partners = useAllPartners()
  if (!partners) return null

  return (
    <ItemSelect
      setKey={setKey}
      initialItem={initialItem}
      items={partners}
      itemDisplay={(item) => item?.name ?? ''}
    />
  )
}
